import React from 'react';
import ReactDOM from 'react-dom/client';
import { DataProvider } from './components/Context/context';
import {ConfigDataProvider} from "./components/Context/ConfigureContext"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <DataProvider>
    <ConfigDataProvider>
      <App />
    </ConfigDataProvider>
  </DataProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
